import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take, map, flatMap } from 'rxjs/operators';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

       
        const token = localStorage.getItem('_x_auth_token');
        if (token) {
            request = request.clone({
                headers: request.headers.set('Authorization', token)  //token is with "Bearer" string included
            });
        }

    //    request = request.clone({ headers: request.headers.set('X-API-Key', 'a5058896-0d2a-4ee0-8b3e-6fe2a38a9fea') }); //localul meu
       return next.handle(request).pipe(map((event: HttpEvent<any>) => event));

    }
}